import { LuIcon, Menu, type MenuClickTriggerProps, type MenuRootProps, type MenuVariantProps } from "@overmap-ai/blocks"
import type { User } from "@overmap-ai/common"
import { useTextFilter } from "@overmap-ai/hooks"
import { memo, type ReactElement } from "react"

import { userFilterCallback } from "../../filtering/utils"
import { modelIconMapping } from "../../mappings/icons"
import { UserMenuCheckboxGroup, type UserMenuCheckboxGroupProps } from "../MenuCheckboxGroups/UserMenuCheckboxGroup"

interface UserMultiSelectProps
	extends
		UserMenuCheckboxGroupProps,
		MenuVariantProps,
		MenuRootProps,
		Omit<MenuClickTriggerProps, "children" | "ref"> {
	children: ReactElement
}

export const UserDropdownCheckboxMenu = memo((props: UserMultiSelectProps) => {
	const {
		children,
		disabled,
		users,
		checkedUsers,
		onCheckedUserChange,
		size,
		variant,
		accentColor,
		radius,
		...rest
	} = props

	const [filteredUsers, filterValue, setFilterValue] = useTextFilter<User>(users, userFilterCallback)

	const isEmpty = filteredUsers.length === 0

	return (
		<Menu.Root {...rest}>
			<Menu.ClickTrigger disabled={disabled}>{children}</Menu.ClickTrigger>
			<Menu.Content size={size} variant={variant} accentColor={accentColor} radius={radius}>
				<Menu.InputRoot>
					<Menu.InputSlot>
						<LuIcon icon={modelIconMapping.search} />
					</Menu.InputSlot>
					<Menu.InputField placeholder="Search" value={filterValue} onValueChange={setFilterValue} />
				</Menu.InputRoot>
				{!isEmpty ? <Menu.Separator /> : null}
				<Menu.Scroll>
					{!isEmpty ? (
						<UserMenuCheckboxGroup
							users={filteredUsers}
							checkedUsers={checkedUsers}
							onCheckedUserChange={onCheckedUserChange}
						/>
					) : null}
				</Menu.Scroll>
			</Menu.Content>
		</Menu.Root>
	)
})
UserDropdownCheckboxMenu.displayName = "UserDropdownCheckboxMenu"
